var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "curated-boxes-page" },
    [
      _c(
        "div",
        {
          staticClass: "back-button",
          on: {
            click: function($event) {
              return _vm.goBack()
            }
          }
        },
        [_vm._v("< BACK")]
      ),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("div", { staticClass: "curated-boxes-images-container" }, [
            _c("img", {
              staticClass: "main-image",
              attrs: { src: _vm.currentImage }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sub-images-container" },
              _vm._l(_vm.curatedBoxImages, function(image) {
                return _c("div", { key: image, staticClass: "sub-image" }, [
                  _c("img", {
                    attrs: { src: image },
                    on: {
                      click: function($event) {
                        return _vm.selectImage(image)
                      }
                    }
                  })
                ])
              }),
              0
            )
          ])
        : _vm.curatedBoxImages.length > 0
        ? _c(
            "VueSlickCarousel",
            {
              attrs: {
                infinite: true,
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            _vm._l(_vm.curatedBoxImages, function(image) {
              return _c(
                "div",
                { key: image, staticClass: "curated-boxes-images-container" },
                [
                  _c("img", {
                    staticClass: "main-image",
                    attrs: { src: image }
                  })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "curated-boxes-main-container" }, [
        _c("p", { staticClass: "main-title" }, [
          _vm._v(_vm._s(_vm.curatedBoxTitle))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box-qty-container" }, [
          _c(
            "div",
            {
              staticClass: "box-qty-input-container",
              class: _vm.canAddMore ? "" : "no-more"
            },
            [
              _c(
                "button",
                {
                  attrs: { disabled: _vm.selectedBoxQty < 2 },
                  on: {
                    click: function($event) {
                      return _vm.incrementBoxQty(false)
                    }
                  }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedBoxQty,
                    expression: "selectedBoxQty"
                  }
                ],
                attrs: { disabled: true, type: "number", min: "1" },
                domProps: { value: _vm.selectedBoxQty },
                on: {
                  blur: function($event) {
                    return _vm.changeBoxQty(null)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.selectedBoxQty = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content: "Not enough inventory",
                        container: false
                      },
                      expression:
                        "{content: 'Not enough inventory', container:false}"
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.incrementBoxQty(true)
                    }
                  }
                },
                [_vm._v("+")]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "price" }, [
            _vm._v(_vm._s(_vm._f("intToDecimalPrice")(_vm.currentPrice)))
          ])
        ]),
        _vm._v(" "),
        !_vm.noDetails
          ? _c("p", { staticClass: "general-advice" }, [
              _vm._v(
                "Write your note and add to cart! If you’re buying multiple boxes, you will have the options to ship to different addresses at checkout."
              )
            ])
          : _c("p", { domProps: { innerHTML: _vm._s(_vm.description) } }),
        _vm._v(" "),
        _c("div", { staticClass: "product-tabs" }, [
          _c(
            "div",
            { staticClass: "tab-container" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "button",
                {
                  key: tab.value,
                  class: _vm.selectedTab == tab.value ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectTab(tab.value)
                    }
                  }
                },
                [_vm._v(_vm._s(tab.title) + " "), _c("span")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-content",
              class: _vm.tabValue == 1 ? "products" : ""
            },
            [
              _vm.selectedTab == 2 && !_vm.noCard
                ? _c("div", { staticClass: "write-container" }, [
                    _c("div", [
                      _c("p", { staticClass: "purple-span" }, [
                        _vm._v(
                          "Type in your message below. A real human will hand write your message and include it in your gift."
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "blank-card-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isEmptyMessage,
                              expression: "isEmptyMessage"
                            }
                          ],
                          attrs: { id: "blankCard", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isEmptyMessage)
                              ? _vm._i(_vm.isEmptyMessage, null) > -1
                              : _vm.isEmptyMessage
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isEmptyMessage,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isEmptyMessage = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isEmptyMessage = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isEmptyMessage = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "blankCard" } }, [
                          _vm._v("Click here if you want your card blank")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.isEmptyMessage
                      ? _c("div", { staticClass: "form-container" }, [
                          _c("div", { staticClass: "message-container" }, [
                            _vm.showAlert
                              ? _c("p", { staticClass: "red-alert" }, [
                                  _vm._v("Please type your message below")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "message" } }, [
                              _vm._v("Your Message:")
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.message.text,
                                  expression: "message.text"
                                }
                              ],
                              attrs: {
                                disabled: _vm.isEmptyMessage,
                                placeholder: "Start typing here...",
                                maxlength: "110",
                                cols: "30",
                                rows: "3",
                                id: "message"
                              },
                              domProps: { value: _vm.message.text },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.message,
                                    "text",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "from-container" }, [
                            _vm.showAlert
                              ? _c("p", { staticClass: "red-alert" }, [
                                  _vm._v("Please type your message below")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "from" } }, [
                              _vm._v("From:")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.message.from,
                                  expression: "message.from"
                                }
                              ],
                              attrs: {
                                disabled: _vm.isEmptyMessage,
                                placeholder: "Your Name",
                                maxlength: "110",
                                id: "from",
                                type: "text"
                              },
                              domProps: { value: _vm.message.from },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.message,
                                    "from",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "purple-span" }, [
                              _vm._v(
                                "Character Remaining " +
                                  _vm._s(_vm.remainingCharacters)
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab == 3 && !_vm.noDetails
                ? _c("div", { staticClass: "description-container" }, [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.description) }
                    })
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "end-buttons-container" }, [
          _c(
            "button",
            {
              staticClass: "happybox-button yellow",
              on: {
                click: function($event) {
                  return _vm.addToCart(true)
                }
              }
            },
            [_vm._v("Save and go to cart")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "happybox-button purple",
              on: { click: _vm.toBuilder }
            },
            [_vm._v("Build a care package from scratch")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "separator" }, [
      _c("div", { staticClass: "line-separator" }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [_vm._v("OR")]),
      _vm._v(" "),
      _c("div", { staticClass: "line-separator" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }